export default __webpack_public_path__ + "static/media/icthyology-new-crop.34698e2e.jpg";